(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('PlanningVersionsMaintenanceController', PlanningVersionsMaintenanceController);

    PlanningVersionsMaintenanceController.$inject = ['$window','$sce','$controller', '$uibModalInstance', 'parameters', 'SoopkitchenUtils', 'Planning', 'PlanTypes'];

    function PlanningVersionsMaintenanceController($window, $sce, $controller, $uibModalInstance, parameters, SoopkitchenUtils, Planning, PlanTypes) {

        var title = 'Maintenance of the version list of plan: <span class="label label-info">'+parameters.planLabel+'</span>';
    // , Delete all internal versions from baseline: <span\n' +
    //         'class="label label-info">'+parameters.selectedBaselineToDelete+'</span>
        angular.extend(this, $controller('SoopkitchenDialogController', {
            "title": title, $sce: $sce, $uibModalInstance:$uibModalInstance}));
        var vm = this;

        /**** Properties ****/

        vm.planType = parameters.planType;
        vm.planLabel = parameters.planLabel;
        vm.selectedBaselineToDelete = parameters.selectedBaselineToDelete;
        vm.isMaster = vm.planType === PlanTypes['master'];
        vm.parameters = [];
        vm.parameters.push({'name': 'Label'});
        if (vm.isMaster) {
            vm.parameters.push({'name': 'ID'});
        }
        vm.parameter = {};
        //Overriding Properties from SoopkitchenDialogController:
        vm.saveText = "Clone";
        vm.showDelta = {};

        /**** Methods ****/
        //Override Methods from SoopkitchenDialogController
        vm.deleteVersions = deleteVersions;
        vm.plans = [];
        getPlans();
        vm.downloadFile = downloadFile;

        function successCloning() {
            SoopkitchenUtils.invokeSweetAlert("Nice!", "You have created the plan " + vm.parameter['Label'], "success", vm.clear);
        }

        function failureCloning(response) {
            SoopkitchenUtils.prettyError(response);
        }

        function getPlans() {
            Planning.getAllVersions(
                {
                    planType: vm.planType,
                    id: vm.planLabel,
                },
                function successCallback(response) {
                    vm.totalPlans = response;
                    var baselineFound = false;
                    for (var count = vm.totalPlans.length; count >=0 ; count--) {
                        if (vm.totalPlans.hasOwnProperty(count)) {
                            var plan = vm.totalPlans[count];
                            vm.showDelta[plan.internalVersion] = false;
                            if (plan.baselineVersion === vm.selectedBaselineToDelete) {
                                break;
                            }
                            // console.debug(plan.baselineVersion);
                            // console.debug(plan.baselineVersion);

                            if (plan.baselineVersion ===0 && plan.isBookmarked === false) {
                                vm.plans.push(plan) ;
                            }
                        }
                    }
                },
                function errorCallback(response) {
                }
            )
        }
        function deleteVersions() {
            console.warn(vm.planType);
            Planning.deleteVersions(
                {
                    planType: vm.planType,
                    planLabel: vm.planLabel,
                    baselineVersion: vm.selectedBaselineToDelete
                },
                function successCallback(response) {
                    SoopkitchenUtils.invokeSweetAlert("Nice!", "You deleted versions of the plan " + vm.planLabel + "prior to baseline version: " + vm.selectedBaselineToDelete    , "success");
                    vm.waiting = false;
                    location.reload();
                },
                function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            )

        }
        function downloadFile () {
            $window.open('api/' + vm.planType + '/download-versions/' + window.encodeURIComponent(vm.planLabel) + '/' +  vm.selectedBaselineToDelete);
        }
    }

})();

